<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <fuse-vertical-navigation class="bg-gray-200 text-black print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="data.navigation.default" [opened]="false">
    <ng-container fuseVerticalNavigationContentHeader>
      <div class="flex items-center justify-between h-20 pt-6 px-8">
        <img class="w-12" src="assets/images/logos/alec-blue-icon.png" alt="Logo image" />
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
          <mat-icon>
            close
          </mat-icon>
        </button>
      </div>
    </ng-container>
  </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <!--  !important -->
  <div class="
            relative
            flex flex-0
            items-center
            w-full
            sm:h-19
            px-4
            md:px-6
            z-49
            shadow
            dark:shadow-none
            dark:border-b
            bg-card
            dark:bg-transparent
            print:hidden
        ">
    <ng-container *ngIf="!isScreenSmall">
      <div class="">
        <button (click)="toggleLeftMenu()" mat-icon-button>
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <!-- Logo -->
      <div class="flex items-center mx-2">
        <div class="hidden lg:flex cursor-pointer" routerLink="/home">
          <img class="dark:hidden w-10" src="assets/images/logos/alec-blue-icon.png" />
          <img class="hidden dark:flex w-12" src="assets/images/logos/alec-blue-icon.png" />
        </div>
        <img class="flex lg:hidden w-8" src="assets/images/logos/alec-blue-icon.png" />
      </div>

      <!-- Project Dropdown -->
      <app-project-starter></app-project-starter>

      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'" [navigation]="data.navigation.horizontal">
      </fuse-horizontal-navigation>

      <!-- <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript w-48">
                <mat-select
                    [panelClass]="'w-72 min-w-72 max-w-72 h-auto max-h-none'"
                    [value]="selectedProject"
                    disableOptionCentering
                    #projectSelect="matSelect"
                >
                    <mat-select-trigger class="text-md">
                        <span>Project:</span>
                        <span class="ml-1 font-medium">{{
                            projectSelect.value | titlecase
                        }}</span>
                    </mat-select-trigger>
                    <ng-container *ngFor="let project of projects">
                        <mat-option
                            class="h-auto py-4 leading-none"
                            [value]="project"
                        >
                            <div class="font-medium">{{ project }}</div>
                            <div
                                class="
                                    mt-1.5
                                    text-sm
                                    whitespace-normal
                                    leading-normal
                                    text-secondary
                                "
                            >
                                {{ project }}
                            </div>
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field> -->
    </ng-container>
    <!-- Navigation toggle button -->
    <ng-container *ngIf="isScreenSmall">
      <!-- <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button> -->
      <button (click)="toggleLeftMenu()" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>

      <app-project-starter></app-project-starter>

      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
      </button>
    </ng-container>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-2">
      <div class="flex items-center" *ngIf="false">
        <!--hidden utill work on dark mode is done-->
        <label class=" mb-0 inline-block align-top leading-6 mat-slide-toggle-content">
          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:sun'"></mat-icon>
        </label>
        <mat-slide-toggle (change)="setScheme($event)">
          <mat-icon class=" icon-size-5" [svgIcon]="'heroicons_solid:moon'">
          </mat-icon>
        </mat-slide-toggle>
      </div>
      <fuse-fullscreen *ngIf="!isScreenSmall"></fuse-fullscreen>
      <!-- <search [appearance]="'bar'"></search> -->
      <!-- <shortcuts [shortcuts]="data?.shortcuts"></shortcuts> -->
      <!-- <messages [messages]="data?.messages"></messages> -->
      <!-- <notifications [notifications]="data?.notifications"></notifications> -->
      <alec-settings *ngIf="role=='Admin' && !isScreenSmall"></alec-settings>
      <user-menu></user-menu>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-row flex-auto w-full">
    <app-left-vertical-navigation [leftNavigationOpen]="leftNavigationOpen" (openedChanged)="openedChanged($event)">
    </app-left-vertical-navigation>

    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <div class="
            relative
            flex flex-0
            items-center
            w-full
            h-14
            sm:h-20
            px-4
            md:px-6
            z-49
            border-t
            bg-card
            dark:bg-transparent
            print:hidden
        ">
    <span class="font-medium text-secondary">ALEC &copy; {{ currentYear }}</span>
  </div>
</div>